import { z } from 'zod'

// Embed communication schemas

export const CreateDesignPayloadSchema = z.object({
  cartId: z.string(),
  productId: z.number().positive(),
  variationId: z.number().positive().optional(),
  templateName: z.string(),
  language: z.enum(['nl', 'fr', 'en', 'de']),
  targetSelector: z.string().optional(), // CSS selector to bind the editor to
})

export const OpenDesignPayloadSchema = z.object({
  designId: z.string(),
  targetSelector: z.string().optional(), // CSS selector to bind the editor to
})

export const EmbedActionSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('create'),
    payload: CreateDesignPayloadSchema,
  }),
  z.object({
    type: z.literal('open'),
    payload: OpenDesignPayloadSchema,
  }),
])

export const EmbedMessageSchema = z.object({
  type: z.enum(['design-studio-ready', 'design-studio-action']),
  action: EmbedActionSchema.optional(),
})

// Type inference
export type CreateDesignPayload = z.infer<typeof CreateDesignPayloadSchema>
export type OpenDesignPayload = z.infer<typeof OpenDesignPayloadSchema>
export type EmbedAction = z.infer<typeof EmbedActionSchema>
export type EmbedMessage = z.infer<typeof EmbedMessageSchema>
